module.exports = __webpack_public_path__ + "img/Doctor.f72f22e.png";